module.exports = __webpack_public_path__ + "a1f0e9b610d498eb080f4a1a0f7f82ac.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/station.png
 ** module id = 1079
 ** module chunks = 0
 **/